export const AUTH_TOKEN_KEY = "auth-token";
export const USER_ID_KEY = "user-id";
export const USER_NAME_KEY = "user-name";
export const USER_EMAIL_KEY = "user-email";
